<div class="contacts-list-section">
  <div class="contacts-list-header">
    <h4>{{ 'cards.clients.contacts.' + getCardTitle() | translate}} ({{contactsCount}})</h4>
    <ng-container *ngIf="canEdit">
      <lxm-button type="beige" icon="plus-dark"
        label="cards.clients.contacts.action.add_contact" (click)="openDialog()" *requiredRights="[UserAction.ManageClients]">
      </lxm-button>
    </ng-container>
  </div>

  <div class="contacts-list-body" [ngSwitch]="hasContacts">
    <div *ngSwitchCase="true">
      <ng-container *ngFor="let contact of contacts | slice:0:4">
        <ng-container *ngTemplateOutlet="contactTemplate; context: {contact: contact}"></ng-container>
      </ng-container>

      <ng-container *ngIf="showAllContacts">
        <ng-container *ngFor="let contact of contacts | slice:4:1000">
          <ng-container *ngTemplateOutlet="contactTemplate; context: {contact: contact}"></ng-container>
        </ng-container>
      </ng-container>

      <div *ngIf="contacts?.length > 4" class="toggle-show-all-contacts" (click)="toggleShowAllContacts()">
        {{(showAllContacts ? 
          'cards.clients.contacts.action.show_less_contacts' : 
          'cards.clients.contacts.action.show_all_contacts') | translate
        }}
      </div>
    </div>
    <no-content 
      *ngSwitchCase="false" 
      heading="cards.clients.contacts.no_contacts_heading"
      text="cards.clients.contacts.no_contacts_text"
      image="no-contacts">
    </no-content>
  </div>
</div>

<ng-template #contactTemplate let-contact="contact">
  <div class="client-contact" (click)="openDialog(contact)">
    <div class="client-contact-row">
      <div class="client-contact-name mr5 bold">
        <span class="{{getContactIcon()}} {{getContactStatusClass(contact)}} mr10"></span>
        <span>{{contact.name || '-'}}</span>
      </div>
      <span class="client-contact-role">{{contact.role}}</span>
    </div>
    <div class="client-contact-row mt5">
      <div class="client-contact-details">
        <span class="mr10" *ngIf="getContactPhoneShort(contact)">
          <phone-number [code]="getContactPhoneCode(contact)" [number]="getContactPhoneShort(contact)"></phone-number>
        </span>
        <span *ngIf="contact.email">{{contact.email}}</span>
      </div>
    </div>
    <div class="client-contact-row mt5" *ngIf="getTranslatedPortfolioDescription(contact)">
      <div class="client-contact-description line-clamp-1">
        <span>{{getTranslatedPortfolioDescription(contact)}}</span>
      </div>
    </div>
  </div>
</ng-template>

